@use "~theme/typography";
@use "~theme/breakpoints";

.label {
  @include typography.field-label;
}

.value {
  display: flex;
}
